import Content from './parts/Content'
import { OnContinue } from '@/features/settings/components/AddPrinterModal/types'
import Modal from '@/features/ui/components/Modal'
import { FC } from 'react'

interface AddPrinterModalProps {
    onContinue: OnContinue
    onCancel: () => void
}

const AddPrinterModal: FC<AddPrinterModalProps> = ({ onContinue, onCancel }) => {
    return (
        <Modal contentVariant="wide" avoidKeyboard contentStyle={{ maxWidth: 465 }}>
            <Content onContinue={onContinue} onCancel={onCancel} />
        </Modal>
    )
}

export default AddPrinterModal
